import { isMinor } from '../../Helpers/Helpers';
const digitalFormsBaseUrl = 'DigitalForms';

export const getPAFFunds = async (axiosGet, assistanceProgramId) => {
    return await axiosGet(`${digitalFormsBaseUrl}/PAFFunds/${assistanceProgramId}`);
}

const PAFLivingInUSSpecialRule = (value, ctx) => {
    if (value?.toLowerCase() === 'no') {
        ctx.specialRuleChangeData('US Patient', value, 'Patient must reside in the U.S. or a U.S. Territory in order to be eligible for the program.');
    }
}

const PAFInsuranceCoverageSpecialRule = (value, ctx) => {
    if (value?.toLowerCase() === 'no') {
        ctx.specialRuleChangeData('Medical or Prescription', value, 'Patient must have medical and/or prescription insurance in order to be eligible for the program.');
    }
}

const PAFGovInsuranceSpecialRule = (value, ctx) => {
    if (value?.toLowerCase() === 'no') {
        ctx.specialRuleChangeData('Gov Insurance ', value, 'Patient must have medical and/or prescription insurance coverage through Medicare (Parts A, B or D), a Medicare Supplemental policy, Medicaid or a Military Benefit (Tricare or Veteran\'s Administration/VA in order to be eligible for the program.')
    }
}

const PAFCurrentTreatmentSpecialRule = (value, ctx) => {
    if (value?.toLowerCase() === 'no') {
        ctx.specialRuleChangeData('Treatment', value, 'Patient must currently be in treatment, planning to begin treatment in the next 60 days, or have been in treatment in the past 6 months in order to be eligible for the program.')
    }
}

const PAFPrescribedInsuranceSpecialRule = (value, ctx) => {
    if (value?.toLowerCase() === 'no') {
        ctx.specialRuleChangeData('Prescribed Insurance', value, 'Patient must have medical or prescription insurance that covers a portion of their pharmaceutical products being prescribed for their diagnosis in order to be eligible for the program.')
    }
}

const PAFEmptyFundIfInsuranceChangesSpecialRule = (value, ctx) => {
    const primaryInsuranceField = 'Insurance Patient Insurance Types PAF';
    const field = ctx.getFieldDef(primaryInsuranceField);
    if (field) {
        ctx.specialRuleChangeData('PAF Fund Selection', undefined);       
        PAFShowMetastaticAttestation(ctx.formData['PAF Fund Selection'], ctx);
    }
}

const PAFCopyApplicantToHealthcareProfFields = (value, ctx) => {
    if (value?.toLowerCase() === 'yes') {
        //first
        ctx.formData['HP First Name'] = ctx.formData['Applicant First Name ']
        //last
        ctx.formData['HP Last Name'] = ctx.formData['Applicant Last Name ']
        //phone
        ctx.formData['HP Phone Number'] = ctx.formData['Applicant Phone Number']
        //facility
        ctx.formData['HP Facility Name '] = ctx.formData['Applicant Practice ']
        //position
        ctx.formData['HP Title'] = ctx.formData['Applicant Position']
    }
}


const PAFOtherPreferNotToDiscloseRace = (value, ctx) => {
    //not allowing for other option to be clicked once prefer not to disclose is clicked
    const raceField = 'Patient Ethnicity ';
    const raceValue = ctx.formData[raceField];

    if (raceValue == null || value == null) return;
    //formData is already being set before it comes into this rule
    //to know the order of what was clicked, you have to note the order of items in the array
    //first index = first item clicked

    //if prefer not to disclose is already checked but you are checking another item
    if (raceValue[0] === 'Prefer not to disclose' && raceValue.length > 1) {
        ctx.formData[raceField] = raceValue.filter(item => item !== 'Prefer not to disclose')
    }
    //if other race items are already checked and you select prefer not to disclose
    else if (raceValue.length > 1 && raceValue[raceValue.length - 1] === 'Prefer not to disclose') {
        ctx.formData[raceField] = ['Prefer not to disclose'];
    }

    //if first item clicked is prefer not to disclose then other is clicked, show other field
    if (raceValue[0] === 'Prefer not to disclose' && value?.includes('Other')) {
        ctx.specialRulePerformAction('show', ['Race Specify']);
    }
    //if other is clicked and anything other than prefer not to disclose is clicked, show other field
    else if (value?.includes('Other') && !value?.includes('Prefer not to disclose')) {
        ctx.specialRulePerformAction('show', ['Race Specify']);
    }
    else {
        ctx.specialRulePerformAction('hide', ['Race Specify']);
    }
}

export const initAuthorizedContactRule = (ctx) => {
    const patientDOB = 'Patient DOB';
    const guardianDOB = 'Guardian DOB';
    ctx.createSpecialRule(patientDOB, PAFGuardianContactRule);
    ctx.createSpecialRule(guardianDOB, PAFGuardianContactUnder18Rule);

    if (patientDOB) {
        const patientDOBAsDate = new Date(ctx.formData[patientDOB]);
        PAFGuardianContactRule(patientDOBAsDate, ctx);
    }

    if (guardianDOB) {
        const guardianDOBAsDate = new Date(ctx.formData[guardianDOB]);
        PAFGuardianContactUnder18Rule(guardianDOBAsDate, ctx);
    }
}

// these fields should only be visible and required if patient is a minor
export const PAFGuardianContactRule = (value, ctx) => {
    if (!value) return;

    const guardianFields = ['Guardian First', 'Guardian Last', 'Guardian Suffix', 'Guardian SSN', 'Guardian DOB', 'Guardian Relationship', 'Guardian Employment',
        'Guardian Address Type', 'Guardian Line 1', 'Guardian Line 2', 'Guardian City', 'Guardian State', 'Guardian Zip', 'Guardian Email',
        'Guardian Email Type', 'Guardian Phone Number', 'Guardian Phone Type', 'Same Address Parent', 'Same Phone Number Parent']

    const action = isMinor(value) ? 'show' : 'hide';

    ctx.specialRulePerformAction(action, guardianFields);
}

export const PAFGuardianContactUnder18Rule = (value, ctx) => {
    if (!value) return;

    const guardianDOB = 'Guardian DOB';

    if (isMinor(value)) {
        ctx.specialRuleChangeData(guardianDOB, value, 'Guardian must be over the age of 18 years old.');
    }
}


export const PAFOnlyAlphabeticCharsSpacesHyphensAllowedSpecialRule = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z\- ]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Patient Name First', 'Patient Name Last', 'Patient City',
    'Authorized Person First Name1', 'Authorized Person Last Name1', 'Authorized Person First Name 2 ',
    'Authorized Person Last Name 2 ', 'Guardian City', 'Race Specify'];
    const checkCharMinimumArr2 = ["Patient Name First", "Patient Name Last"];

    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove numbers and/or special characters as they are not acceptable in the provider portal.');
        });
    }
    else {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharMinimumArr2);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            if (fieldValue.trim().length < 2) {
                const fieldLabel = ctx.getFieldDef(field).label;
                ctx.specialRuleChangeData(field, fieldValue, `${fieldLabel} must contain at least 2 characters.`);
            }
        })
    }
}

export const PAFOnlyAlphanumericSpacesHyphensAllowedSpecialRule = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z0-9 \-]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Patient Address 1', 'Patient Address 2', 'Guardian Line 1', 'Guardian Line 2'];

    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove special characters as they are not acceptable in the provider portal.');
        });
    }
}

export const PAFOnlyAlphanumericSpacesAllowedSpecialRule = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z0-9 ]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Insurance Primary Medical Insurance ID_Policy Number', 'Insurance Primary Medical Insurance Group Number'];

    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove special characters as they are not acceptable in the provider portal.');
        });
    }
}

export const PAFAlphabeticSpacesOnlyAllowedSpecialRule = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z ]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Insurance Primary Medical Insurance Policy Holder Name'];

    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove numbers and/or special characters as they are not acceptable in the provider portal.');
        });
    }
}


export const PAFEnforceMinimumCharLength2 = (value, ctx) =>{
    const checkCharMinimumArr2 = ['Applicant First Name ', 'Applicant Last Name '];
    const fieldsToCheck2 = GetFieldsToCheck(ctx, value, checkCharMinimumArr2);
    fieldsToCheck2.forEach(field =>{

        const fieldValue = ctx.formData[field];
        if(fieldValue.trim().length < 2){
            const fieldLabel = ctx.getFieldDef(field).label;
            ctx.specialRuleChangeData(field, fieldValue, `${fieldLabel} must contain at least 2 characters.`);
        }
    })
}

export const PAFEnforceMinimumCharLength3 = (value, ctx) => {
    const checkCharMinimumArr3 = ['Applicant Practice ', 'Applicant Position', 'HP Facility Name ', 'HP Title', 'Referral Facility Name'];   
    const fieldsToCheck3 = GetFieldsToCheck(ctx, value, checkCharMinimumArr3);
    fieldsToCheck3.forEach(field => {
        const fieldValue = ctx.formData[field];
        if (fieldValue.trim().length < 3) {
            const fieldLabel = ctx.getFieldDef(field).label;
            ctx.specialRuleChangeData(field, fieldValue, `${fieldLabel} must contain at least 3 characters.`);
        }
    })
}

export const PAFRequireEmailTypeFieldWhenEmailHasValue = (value, ctx) =>{
    const referredBy = ctx.formData['Referral'];
    if(value){
        const fieldIndex = Object.values(ctx.formData).indexOf(value);
        const fieldName = Object.keys(ctx.formData)[fieldIndex];
        if(fieldName === "Referral Email"){ //Healthcare Facility
            ctx.specialRuleChangeData('EmailTypeHF', '', 'Email type is required when email address is provided.');
        }
        else if(fieldName === "Referred 2 Email"){ //Healthcare Professional
            ctx.specialRuleChangeData('EmailTypeHP', '', 'Email type is required when email address is provided.');
        }
    }

    else{
        if(referredBy === 'Healthcare Facility'){
            ctx.specialRuleChangeData('EmailTypeHF', '', '');
        }
        else{
            ctx.specialRuleChangeData('EmailTypeHP', '', '');
        }
        
    }
    //specialRulePerformAction not working due to interfering action/rule
    //using specialRuleChangeData instead to manipulate field to be required
}

export const PAFCheckEmailValueWhenEmailTypeIsChosen = (value, ctx) =>{
    const emailHFValue = ctx.formData['Referral Email'];
    const emailTypeHF = ctx.formData['EmailTypeHF'];

    const emailHPValue = ctx.formData['Referred 2 Email'];
    const emailTypeHP = ctx.formData['EmailTypeHP'];

    const referredBy = ctx.formData['Referral'];

    if(referredBy === 'Healthcare Facility'){
        //email has a value and email type is blank
        if(emailHFValue.length > 0 && (emailTypeHF == null || emailTypeHF === "")){
            ctx.specialRuleChangeData('EmailTypeHF', '', 'Email type is required when email address is provided.');
        }
        else if(emailHFValue.length === 0 && (emailTypeHF != null && emailTypeHF != "")){
            ctx.specialRuleChangeData('Referral Email', '', 'Email is required when email type is provided.');
        }
        else if(emailHFValue.length === 0 && (emailTypeHF == null || emailTypeHF === "")){
            ctx.specialRuleChangeData('Referral Email', '', '');
        }
    }
    else if(referredBy === 'Healthcare Professional'){
        if(emailHPValue.length > 0 && (emailTypeHP == null|| emailTypeHP === "")){
            ctx.specialRuleChangeData('EmailTypeHP', '', 'Email type is required when email address is provided.');
        }
        else if(emailHPValue.length === 0 && (emailTypeHP != null && emailTypeHP != "")){
            ctx.specialRuleChangeData('Referred 2 Email', '', 'Email is required when email type is provided.');
        }
        else if(emailHPValue.length === 0 && (emailTypeHP == null || emailTypeHP === "")){
            ctx.specialRuleChangeData('Referred 2 Email', '', '');
        }
    }
}

export const PAFShowMetastaticAttestation = (value, ctx) => {
    if(value?.toLowerCase().includes("metastatic")){
        ctx.specialRulePerformAction('show', ['Stage Attest']);
    }
    else{
        ctx.specialRulePerformAction('hide', ['Stage Attest']);
        ctx.formData['Stage Attest'] = '';
    }
}

function GetFieldsToCheck(ctx, value, arrToCheckAgainst) {
    const formData = Object.keys(ctx.formData).map(function (key) {
        return [key, ctx.formData[key]];
    })
    var arr = [];
    for (var i = 0; i < formData.length; i++) {
        let dataKey = formData[i][0];
        let dataValue = formData[i][1];
        if (dataValue === value) {
            arr.push(dataKey);
        }
    }
    const intersection = arr.filter(element => arrToCheckAgainst.includes(element));
    return intersection;
}

export const createPAFRules = (meta, ctx) => {
    initAuthorizedContactRule(ctx);
    ctx.createSpecialRule('US Patient', PAFLivingInUSSpecialRule);
    ctx.createSpecialRule('Medical or Prescription', PAFInsuranceCoverageSpecialRule);
    ctx.createSpecialRule('Patient Ethnicity ', PAFOtherPreferNotToDiscloseRace);
    ctx.createSpecialRule('Gov Insurance ', PAFGovInsuranceSpecialRule);
    ctx.createSpecialRule('HP 1 ', PAFCopyApplicantToHealthcareProfFields);
    ctx.createSpecialRule('Treatment', PAFCurrentTreatmentSpecialRule);
    ctx.createSpecialRule('Prescribed Insurance', PAFPrescribedInsuranceSpecialRule);
    ctx.createSpecialRule('Insurance Patient Insurance Types PAF', PAFEmptyFundIfInsuranceChangesSpecialRule);
    ctx.createSpecialRule('Referred 2 Email', PAFRequireEmailTypeFieldWhenEmailHasValue);
    ctx.createSpecialRule('Referral Email', PAFRequireEmailTypeFieldWhenEmailHasValue);
    ctx.createSpecialRule('EmailTypeHF', PAFCheckEmailValueWhenEmailTypeIsChosen);
    ctx.createSpecialRule('EmailTypeHP', PAFCheckEmailValueWhenEmailTypeIsChosen);
    ctx.createSpecialRule('PAF Fund Selection', PAFShowMetastaticAttestation);

    PAFLivingInUSSpecialRule(ctx.formData['US Patient'], ctx);
    PAFInsuranceCoverageSpecialRule(ctx.formData['Medical or Prescription'], ctx);
    PAFOtherPreferNotToDiscloseRace(ctx.formData['Patient Ethnicity '], ctx);
    PAFGovInsuranceSpecialRule(ctx.formData['Gov Insurance '], ctx);
    PAFCopyApplicantToHealthcareProfFields(ctx.formData['HP 1 '], ctx);
    PAFCurrentTreatmentSpecialRule(ctx.formData['Treatment'], ctx);
    PAFPrescribedInsuranceSpecialRule(ctx.formData['Prescribed Insurance'], ctx);
    PAFRequireEmailTypeFieldWhenEmailHasValue(ctx.formData['Referred 2 Email'], ctx);
    PAFRequireEmailTypeFieldWhenEmailHasValue(ctx.formData['Referral Email'], ctx);
    PAFCheckEmailValueWhenEmailTypeIsChosen(ctx.formData['EmailTypeHF'], ctx);
    PAFCheckEmailValueWhenEmailTypeIsChosen(ctx.formData['EmailTypeHP'], ctx);
    PAFShowMetastaticAttestation(ctx.formData['PAF Fund Selection'], ctx);

    const alphabeticSpacesHyphensOnlyFields = ['Patient Name First', 'Patient Name Last', 'Patient City',
        'Authorized Person First Name1', 'Authorized Person Last Name1', 'Authorized Person First Name 2 ',
        'Authorized Person Last Name 2 ', 'Guardian City', 'Race Specify'];
    alphabeticSpacesHyphensOnlyFields.forEach(field => {
        ctx.createSpecialRule(field, PAFOnlyAlphabeticCharsSpacesHyphensAllowedSpecialRule);
        PAFOnlyAlphabeticCharsSpacesHyphensAllowedSpecialRule(ctx.formData[field], ctx);
    });

    const alphanumericSpacesHyphensOnlyFields = ['Patient Address 1', 'Patient Address 2', 'Guardian Line 1', 'Guardian Line 2'];
    alphanumericSpacesHyphensOnlyFields.forEach(field => {
        ctx.createSpecialRule(field, PAFOnlyAlphanumericSpacesHyphensAllowedSpecialRule);
        PAFOnlyAlphanumericSpacesHyphensAllowedSpecialRule(ctx.formData[field], ctx);
    });

    const alphanumbericSpacesOnlyFields = ['Insurance Primary Medical Insurance ID_Policy Number', 'Insurance Primary Medical Insurance Group Number'];
    alphanumbericSpacesOnlyFields.forEach(field => {
        ctx.createSpecialRule(field, PAFOnlyAlphanumericSpacesAllowedSpecialRule);
        PAFOnlyAlphanumericSpacesAllowedSpecialRule(ctx.formData[field], ctx);
    });

    const alphabeticSpacesOnlyFields = ['Insurance Primary Medical Insurance Policy Holder Name'];
    alphabeticSpacesOnlyFields.forEach(field => {
        ctx.createSpecialRule(field, PAFAlphabeticSpacesOnlyAllowedSpecialRule);
        PAFAlphabeticSpacesOnlyAllowedSpecialRule(ctx.formData[field], ctx);
    });

    const minimumCharFields3 = ['Applicant Practice ', 'Applicant Position', 'HP Facility Name ', 'HP Title', 'Referral Facility Name'];        
    minimumCharFields3.forEach(field => {
        ctx.createSpecialRule(field, PAFEnforceMinimumCharLength3);
        PAFEnforceMinimumCharLength3(ctx.formData[field], ctx);
    });

    const mimimumCharFields2 = ['Applicant First Name ', 'Applicant Last Name ']
    mimimumCharFields2.forEach(field => {
        ctx.createSpecialRule(field, PAFEnforceMinimumCharLength2);
        PAFEnforceMinimumCharLength2(ctx.formData[field], ctx);
    });



}
